export enum CloudManagerMessageType {
  Request = "CLOUD_MANAGER_REQUEST",
  Response = "CLOUD_MANAGER_RESPONSE",
  Event = "CLOUD_MANAGER_EVENT",
  Subscribe = "CLOUD_MANAGER_SUBSCRIBE",
}

export type CloudManagerAction =
  | "setup"
  | "logWithTimestamp"
  | "logout"
  | "cancelAllUploads"
  | "fetchFoldersMetaDataArray"
  | "downloadCloudMetadata"
  | "downloadCloudUnsafeFeed"
  | "cancelFetchingProject"
  | "fetchProject"
  | "deleteProjects"
  | "uploadProject"
  | "uploadProjectsMetaDataArray"
  | "deleteProject"
  | "downloadFontsFileNames"
  | "setFirebaseToken"
  | "isUploading"
  | "isDownloading"
  | "didHaveSync"
  | "progressPercent";

export interface CloudManagerRequestMessage {
  type: CloudManagerMessageType.Request;
  requestId: string;
  action: CloudManagerAction;
  args?: unknown[];
}

export interface CloudManagerResponseMessage {
  type: CloudManagerMessageType.Response;
  requestId: string;
  ok: boolean;
  result?: unknown;
  error?: string;
}

export interface CloudManagerSubscribeMessage {
  type: CloudManagerMessageType.Subscribe;
}

export interface CloudManagerEventMessage {
  type: CloudManagerMessageType.Event;
  event: string;
  payload?: unknown;
}

export type CloudManagerMessage =
  | CloudManagerRequestMessage
  | CloudManagerResponseMessage
  | CloudManagerSubscribeMessage
  | CloudManagerEventMessage;
